import _ from 'underscore';
import React from 'react';
import { mergeStyles } from '@fluentui/react';
import { HelpIcon } from '@bingads-webui-campaign-react/help';

export const formatFuncs = {
  integer: i18n => _.compose(
    i18n.decimalToIntegerFormatter(),
    Number
  ),
  percentage: () => _.compose(
    v => `${v.toFixed(2)}%`,
    Number
  ),
  decimal: i18n => _.compose(
    i18n.decimalToFixedFormatter(),
    Number
  ),
  thousandth: i18n => _.compose(
    i18n.decimalToFixedFormatter(),
    value => value / 1000,
    Number
  ),
};


export const generateHelpId = ({ name, helpId }) => {
  if (_.isFunction(helpId)) {
    return helpId(name);
  }
  // String help ID
  if (_.isString(helpId)) {
    return helpId;
  }
  // No help ID
  if (_.isNull(helpId)) {
    return null;
  }
  // Default performance metrics help ID
  return `Page_CampaignGrids_${name}`;
};

export const headerTextStyle = hasHelpIcon => ({
  overflow: 'hidden',
  maxWidth: hasHelpIcon ? 'calc(100% - 22px)' : '100%',
  textOverflow: 'ellipsis',
  display: 'inline-block',
  verticalAlign: 'middle',
});

export const buildColumn = ({
  key, name, helpId, title, fieldName, minWidth, maxWidth, sortable = true,
}) => ({
  key,
  className: key,
  minWidth: minWidth || 120,
  maxWidth: maxWidth || 300,
  isResizable: true,
  name,
  fieldName: fieldName || key,
  sortable,
  title,
  onRenderHeader: () => {
    const helpIcon = helpId ? (
      <span className="grid-header-helpId">
        <HelpIcon topic={generateHelpId({ helpId })} disabled />
      </span>
    ) : null;
    return (
      <div>
        <span className={`grid-header-text ${mergeStyles(headerTextStyle(helpIcon))}`}>
          {title}
        </span>
        {helpIcon}
      </div >
    );
  },
  onRender: (item) => {
    const property = fieldName || key;
    const properties = property.split('/');
    return _.get(item, [properties], '-');
  },
});

export const FluctuationType = {
  Default: 0,
  Impression: 1,
  Click: 2,
  Spend: 3,
  Conversion: 4,
  Max: 500,
};

export const FluctuationEnumToStringMap = (() => {
  const keyList = _.keys(FluctuationType);
  return _.object(keyList, keyList);
})();

export const ColumnNameToFluctuationTypeEnum = {
  Clicks: FluctuationEnumToStringMap.Click,
  Impressions: FluctuationEnumToStringMap.Impression,
  Spend: FluctuationEnumToStringMap.Spend,
  Conversions: FluctuationEnumToStringMap.Conversion,
};

export const hasFluctuations = ({
  propertyName,
  availableInsightTypeIds,
} = {}) => {
  if (!_.isEmpty(propertyName) && availableInsightTypeIds) {
    return _.contains(
      availableInsightTypeIds,
      ColumnNameToFluctuationTypeEnum[propertyName]
    );
  }
  return false;
};

